import { AlertCircle, Check } from "lucide-react";
import { cn } from "@/lib/utils";

export interface TabDef {
  label: string;
}

interface TabStripProps {
  tabs: TabDef[];
  current: number;
  visited: number[];
  errorTabs: number[];
  onSelect: (index: number) => void;
}

/** Horizontal tab strip with visited ✓ and error ! marks. */
export function TabStrip({ tabs, current, visited, errorTabs, onSelect }: TabStripProps) {
  return (
    <div className="flex flex-wrap gap-2 border-b pb-3">
      {tabs.map((tab, i) => {
        const isCurrent = i === current;
        const hasError = errorTabs.includes(i);
        const isVisited = visited.includes(i);
        return (
          <button
            key={tab.label}
            type="button"
            onClick={() => onSelect(i)}
            aria-current={isCurrent ? "step" : undefined}
            className={cn(
              "flex items-center gap-1.5 rounded-md px-3 py-1.5 text-sm font-medium transition-colors",
              isCurrent
                ? "bg-primary text-primary-foreground"
                : hasError
                  ? "text-destructive hover:bg-destructive/10"
                  : "text-muted-foreground hover:bg-muted",
            )}
          >
            {hasError ? (
              <AlertCircle className="size-3.5" />
            ) : isVisited && !isCurrent ? (
              <Check className="size-3.5" />
            ) : null}
            {tab.label}
          </button>
        );
      })}
    </div>
  );
}
